<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #fdb92c;
  color: #fdb92c !important;
  background-color: white !important;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #faa908 !important;
}

.el-pagination.is-background .el-pager li {
  background-color: #ffffff !important;
  border: 1px solid #e0e5ed;
  border-radius: 2px;
}

.el-notification  {
    z-index: 5000 !important;
}

</style>
